import { FC, useEffect } from "react";
import {
  ProductCard,
  ProductlistingDesktopFilters,
  ProductListingMain,
  ProductListingMobileFilters,
  StoryRow,
} from "../../organisms";
import { useProductListingFilter } from "./hooks/useProductListingFilter/useProductListingFilter";
import { TransformedProductEntity } from "../../../types/transformed_product_entity";
import { TransformedFilterEntity } from "../../../types/transformedFilterEntity";
import { analytics } from "../../analytics";
import { CircularProgress, Container, Stack } from "@mui/material";
import { useInfiniteScroll } from "./hooks/useInfiniteScroll";

interface Props {
  eventId: string;
  count: number;
  products: TransformedProductEntity[];
  filters: TransformedFilterEntity[];
  title: string;
  sortBy?: string;
  banners?: {
    desktop: null | string;
    mobile: null | string;
  };
}

export const ProductListings: FC<Props> = ({
  eventId,
  title,
  count,
  products,
  filters,
  banners = { desktop: null, mobile: null },
}) => {
  const {
    priceRange,
    setPriceRange,
    queryFilters,
    setQueryFilters,
    sortBy,
    setSortBy,
    page,
    setPage,
  } = useProductListingFilter();

  useEffect(() => {
    analytics.pushViewItemList({ page, pageTitle: title, products, eventId });
  }, [page, title, products]);

  return (
    <Stack>
      <Container maxWidth="xl">
        <Stack gap={4}>
          {banners.desktop ? (
            <img
              src={banners.desktop}
              className="w-full h-auto hidden lg:block"
            />
          ) : null}
          {banners.mobile ? (
            <img
              src={banners.mobile}
              className="w-full h-auto block lg:hidden"
            />
          ) : null}
          <StoryRow />
          <div className="grid grid-cols-12 gap-4 lg:gap-6 xl:gap-12">
            <div className="col-span-3 hidden lg:block">
              <ProductlistingDesktopFilters
                filters={filters}
                filterQuery={queryFilters}
                setFilterQuery={setQueryFilters}
                priceRange={priceRange}
                setPriceRange={setPriceRange}
              />
            </div>
            <div className="col-span-12 lg:col-span-9 mb-8 h-full">
              <ProductListingMain
                title={title}
                count={count}
                sortBy={sortBy}
                setSortBy={setSortBy}
                page={page}
                setPage={setPage}
                initialProducts={products}
              />
            </div>
          </div>
        </Stack>
      </Container>
      <div className="block lg:hidden sticky bottom-0 z-50 mt-8">
        <ProductListingMobileFilters
          filters={filters}
          setFilterQuery={setQueryFilters}
          filterQuery={queryFilters}
          sortBy={sortBy}
          setSortBy={setSortBy}
          priceRange={priceRange}
          setPriceRange={setPriceRange}
        />
      </div>
    </Stack>
  );
};
